"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isPlayWrightNode", {
    enumerable: true,
    get: function() {
        return isPlayWrightNode;
    }
});
const isPlayWrightNode = ()=>process.env.PLAYWRIGHT_TEST === 'true';
